/* V·lette Black Friday sale info dialog — custom assets only. */
(function () {
  'use strict';
  if (window.__vletteBlackFridaySheetInitialized) return;
  window.__vletteBlackFridaySheetInitialized = true;

  // The shared V·lette assets snippet is rendered by each custom section.
  // Rendered templates are inert; only one dialog is ever mounted, on demand.
  var sheet = null;
  var panel = null;
  var previousFocus = null;
  var hideTimer = null;
  var closeTime = 260;

  function getSheet() {
    if (sheet && sheet.isConnected) return sheet;
    sheet = document.querySelector('[data-vlette-black-friday-sheet]');
    if (!sheet) {
      var template = document.querySelector('template[data-vlette-black-friday-info-template]');
      if (!template || !template.content) return null;
      document.body.appendChild(template.content.cloneNode(true));
      sheet = document.querySelector('[data-vlette-black-friday-sheet]');
    }
    panel = sheet ? sheet.querySelector('.vlette-black-friday-sheet__panel') : null;
    return sheet;
  }

  function halt(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  }

  function openSheet(trigger) {
    if (!getSheet()) return;
    window.clearTimeout(hideTimer);
    if (!sheet.hidden && sheet.classList.contains('is-visible')) return;
    previousFocus = document.activeElement || trigger;
    sheet.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vlette-black-friday-is-open');
    window.requestAnimationFrame(function () {
      sheet.classList.add('is-visible');
      if (sheet && !sheet.hidden && panel) panel.focus({preventScroll: true});
    });
  }

  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    window.clearTimeout(hideTimer);
    sheet.classList.remove('is-visible');
    sheet.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vlette-black-friday-is-open');
    hideTimer = window.setTimeout(function () {
      sheet.hidden = true;
      if (previousFocus && document.contains(previousFocus)) previousFocus.focus({preventScroll: true});
      previousFocus = null;
    }, closeTime);
  }

  // Shopify sections/older product-template markup can render sale messaging
  // without the icon. Add it once so the product-page entry point is reliable.
  function ensureProductInfoTriggers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var rows = scope.querySelectorAll('.vlette-product-page-sale-copy');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.querySelector('[data-vlette-black-friday-info-trigger]')) continue;
      // Do not show an information icon for non-sale text.
      if (!row.querySelector('.vlette-product-page-sale-saving')) continue;
      var target = row.querySelector('.vlette-product-page-sale-saving-group') || row;
      var link = document.createElement('a');
      link.href = '#vlette-black-friday-info-sheet';
      link.className = 'vlette-black-friday-info-trigger vlette-black-friday-info-trigger--product';
      link.setAttribute('role', 'button');
      link.setAttribute('data-vlette-black-friday-info-trigger', '');
      link.setAttribute('aria-controls', 'vlette-black-friday-info-sheet');
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-label', 'View Black Friday sale details');
      var icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = 'i';
      link.appendChild(icon);
      target.appendChild(link);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ensureProductInfoTriggers(document); });
  } else {
    ensureProductInfoTriggers(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    ensureProductInfoTriggers(event.target);
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    // The icon and nearby sale text are one safe touch target on cards.
    var trigger = target.closest('[data-vlette-black-friday-info-trigger], [data-vlette-black-friday-info-area]');
    if (trigger) {
      halt(event);
      openSheet(trigger);
      return;
    }
    var close = target.closest('[data-vlette-black-friday-close]');
    if (sheet && close && close.closest('[data-vlette-black-friday-sheet]') === sheet) {
      halt(event);
      closeSheet();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!sheet || sheet.hidden || !sheet.classList.contains('is-visible')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeSheet();
    } else if (event.key === 'Tab') {
      // Keep keyboard focus inside the dialog until it is dismissed.
      var focusable = Array.prototype.slice.call(sheet.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')).filter(function (item) {
        return item.getClientRects().length > 0;
      });
      if (!focusable.length) {
        event.preventDefault();
        panel.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!sheet.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
